import { colors } from "@/components/ui/badge/Badge";

/**
 * Maps agentic task `status` to `Badge` `color` keys, aligned with the
 * meetings module palette (`getMeetingStatusBadgeColor` in
 * `app/components/meetings/meetingStatusUtils.ts` on `feature/meetings`):
 *
 * - `scheduled` → `blue` here: `assigned`, `queued` (waiting / not yet running)
 * - `capturing` / `transcribing` → `indigo` here: `working` (active runner)
 * - `needs_review` → `amber`
 * - `approved` → `green` here: `done`
 * - `cancelled` → `zinc` here: `auto_closed` and unknown
 * - `blocked` stays `red` (meetings has no direct analogue; keeps alert semantics)
 */
export function getAgenticTaskStatusBadgeColor(
  status: string
): keyof typeof colors {
  switch (status) {
    case "working":
      return "indigo";
    case "assigned":
    case "queued":
      return "blue";
    case "needs_review":
      return "amber";
    case "blocked":
      return "red";
    case "done":
      return "green";
    case "auto_closed":
      return "zinc";
    default:
      return "zinc";
  }
}
